import { ref as p } from "vue";
const i = () => {
  const t = p("Copy"), a = (e) => {
    const o = document.createElement("textarea");
    o.value = e, document.body.appendChild(o), o.focus(), o.select();
    try {
      document.execCommand("copy");
    } catch (c) {
      console.error("Unable to copy to clipboard", c);
    }
    document.body.removeChild(o);
  }, r = (e) => {
    const o = e === "success" ? "Copied" : "Copy failed";
    t.value = o, setTimeout(() => {
      t.value = "Copy";
    }, 3e3);
  };
  return {
    copyTooltip: t,
    copyToClipboard: (e, o) => {
      if (!e)
        console.warn("No content to copy"), t.value = "No content to copy";
      else
        try {
          window.isSecureContext && navigator.clipboard ? navigator.clipboard.writeText(e) : a(e), r("success");
        } catch (c) {
          console.error("Failed to copy to clipboard", c), r("failed");
        }
    }
  };
};
export {
  i as u
};
